var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwint(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    className: "\\u2699    as-iu as-r as-s as-t as-c2 as-1k as-1l as-3s as-8x \\u26991q16c7l",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M0 0h32v32H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27 21.225c0 .323-.233.724-.512.878l-9.976 5.717c-.28.17-.745.17-1.024 0l-9.976-5.717c-.28-.17-.512-.555-.512-.878V9.775c0-.323.233-.724.512-.878l9.976-5.717c.28-.17.745-.17 1.024 0l9.976 5.717c.28.17.512.555.512.878v11.45Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bi_twint__a_:r9v:_0)",
    d: "m20.633 15.285-2.56 3.652-1.317-1.96 1.517-2.197c.276-.386.889-1.47.184-2.94-.567-1.187-1.793-1.766-2.866-1.766-1.073 0-2.253.535-2.866 1.767-.705 1.41-.092 2.523.169 2.895 0 0 .843 1.202 1.547 2.211l1.15 1.604 1.716 2.538c.016.015.291.416.767.416.46 0 .735-.401.781-.446l4.03-5.774h-2.252Zm-5.042.089s-.674-.995-1.103-1.678c-.476-.742.06-1.84 1.103-1.84 1.057 0 1.578 1.098 1.103 1.84-.429.698-1.103 1.678-1.103 1.678Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bi_twint__b_:r9v:_1)",
    d: "m13.108 18.818-2.528-3.43s-.675-.994-1.104-1.677c-.475-.742.062-1.84 1.104-1.84.138 0 .26.014.367.044l.89-1.574a3.45 3.45 0 0 0-1.257-.252c-1.073 0-2.253.534-2.866 1.766-.705 1.41-.092 2.524.168 2.895l4.414 6.339c.03.06.322.46.782.46.475 0 .735-.386.781-.445l1.333-1.96-1.149-1.633-.935 1.307Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "bi_twint__a_:r9v:_0",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(45 -4.41 19.541) scale(21.2876)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.092,
    stopColor: "#FFC800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.174,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.253,
    stopColor: "#FFAB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF9100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.405,
    stopColor: "#FF7000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.479,
    stopColor: "#FF4700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF1800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.582,
    stopColor: "red"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "red"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "bi_twint__b_:r9v:_1",
    x1: 6.737,
    x2: 15.421,
    y1: 12.026,
    y2: 20.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B4E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.201,
    stopColor: "#00B0E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#01A5DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.574,
    stopColor: "#0292CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755,
    stopColor: "#0377BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.932,
    stopColor: "#0455A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#054696"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwint);
export default __webpack_public_path__ + "static/media/TWINT.b772989861f859ca3bab207a64b3a724.svg";
export { ForwardRef as ReactComponent };